import { Text } from '@twilio-paste/core/text';

import { DataGridEmptyState } from '../../common/DataGrid';

export function ScopesTableEmptyState() {
  return (
    <DataGridEmptyState colSpan={5}>
      <Text as="p" fontSize="fontSize40" marginBottom="space70">
        No scopes found.
      </Text>
    </DataGridEmptyState>
  );
}
